module.exports = __webpack_public_path__ + "static/allbooties-038034549905ef217b263b5edebfbea6.jpeg";